import { identity } from 'lodash-es';
import { alias as segmentAlias } from './tools/segment';

/**
 * Track when a modal has been dismissed/closed.
 */
export const alias = (userId: number): Promise<void> => {
  // Note: Track should _always_ resolve such that any errors in Track
  // won't affect UX, so handle any rejections.
  return segmentAlias(`${userId}`).then(undefined, identity);
};
